(function ($) {

    /* ===== mobile overlay open/close ===== */
    var $header = $('[data-header]');
    var $burger = $header.find('.burger');
    var $overlay = $('#mobileMenu');
    if (!$header.length || !$burger.length || !$overlay.length) return;

    var $btnClose = $overlay.find('.close');
    var $list = $overlay.find('.mobile-menu-list');

    function openMenu() {
        $overlay.prop('hidden', false).addClass('mobile-menu--open');
        $burger.addClass('burger--active').attr('aria-expanded', 'true');
        $('body').css('overflow', 'hidden');
        if ($btnClose.length) $btnClose.trigger('focus');
    }
    closeMenu();
    function closeMenu() {
        $overlay.removeClass('mobile-menu--open');
        $burger.removeClass('burger--active').attr('aria-expanded', 'false');
        $('body').css('overflow', '');
        requestAnimationFrame(function () { $overlay.prop('hidden', true); });
    }

    $burger.on('click touchstart', function (e) {
        e.preventDefault();
        ($burger.attr('aria-expanded') === 'true') ? closeMenu() : openMenu();
    });
    $btnClose.on('click touchstart', function (e) { e.preventDefault(); closeMenu(); });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && !$overlay.prop('hidden')) closeMenu();
    });
    $overlay.on('click', function (e) {
        if (e.target === e.currentTarget) closeMenu();
    });

    /* ===== mobile accordion (ACF menu) ===== */
    if ($list.length) {
        // init: hide all submenus, set ARIA
        $list.find('li.menu-item-has-children').each(function () {
            var $li = $(this);
            var $a = $li.children('a');
            var $sub = $li.children('.sub-menu'); // <ul.sub-menu> или <div.sub-menu.mega-sub>
            $a.attr({ 'role': 'button', 'aria-haspopup': 'true', 'aria-expanded': 'false' });
            $sub.hide().attr('hidden', true);
        });

        // click to toggle (accordion: closes siblings)
        $overlay.on('click', 'li.menu-item-has-children > a', function (e) {
            e.preventDefault();
            var $a = $(this);
            var $li = $a.parent();
            var $sub = $li.children('.sub-menu');
            var isOpen = $a.attr('aria-expanded') === 'true';

            // close other open siblings on same level
            $li.siblings('.menu-item-has-children').each(function () {
                var $aa = $(this).children('a[aria-expanded="true"]');
                if ($aa.length) {
                    $aa.attr('aria-expanded', 'false').removeClass('is-open');
                    $li.removeClass('active');
                    $(this).children('.sub-menu').stop(true, true).slideUp(200).attr('hidden', true);
                }
            });

            if (isOpen) {
                $a.attr('aria-expanded', 'false').removeClass('is-open');
                $li.removeClass('active');
                $sub.stop(true, true).slideUp(200).attr('hidden', true);
            } else {
                $a.attr('aria-expanded', 'true').addClass('is-open');
                $li.addClass('active');
                $sub.stop(true, true).slideDown(200).attr('hidden', false);
            }
        });

        // accessibility: Enter/Space toggles
        $overlay.on('keydown', 'li.menu-item-has-children > a', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    }
    var $root = $('#mobileMenu');                  // у тебя это <div class="mobile-list" id="mobileMenu">
    if (!$root.length) return;

    var $list = $root.find('.mobile-menu-list');

    // не даём "внешним" document-click хендлерам закрывать нас
    $root.on('click', function (e) { e.stopPropagation(); });

    // Инициализация: скрыть подменю и проставить ARIA
    $list.find('li.menu-item-has-children').each(function () {
        var $li = $(this);
        var $a = $li.children('a');
        var $sub = $li.children('.sub-menu');        // <ul.sub-menu> или <div.sub-menu mega-sub>
        // если подменю реально есть — делаем кнопку
        if ($sub.length) {
            $a.attr({ 'role': 'button', 'aria-haspopup': 'true', 'aria-expanded': 'false' });
            $sub.hide().attr('hidden', true);
        }
    });

    function openItem($li) {
        var $a = $li.children('a');
        var $sub = $li.children('.sub-menu');
        $li.addClass('active');
        $a.attr('aria-expanded', 'true').addClass('is-open');
        $sub.stop(true, true).slideDown(200).attr('hidden', false);
    }
    function closeItem($li) {
        var $a = $li.children('a');
        var $sub = $li.children('.sub-menu');
        $li.removeClass('active');
        $a.attr('aria-expanded', 'false').removeClass('is-open');
        $sub.stop(true, true).slideUp(200).attr('hidden', true);
    }

    // Клик по пункту с подпунктами — аккордеон
    $list.on('click', 'li.menu-item-has-children > a', function (e) {
        // ВАЖНО: блокируем всплытие и "дубли" от сторонних хендлеров
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

        var $a = $(this);
        var $li = $a.parent();
        var $sub = $li.children('.sub-menu');
        if (!$sub.length) { return; }                 // на всякий случай

        var isOpen = $a.attr('aria-expanded') === 'true';
        var href = $a.attr('href');

        // Закрыть соседей на том же уровне
        $li.siblings('.menu-item-has-children').each(function () {
            closeItem($(this));
        });

        if (!isOpen) {
            // Первый тап — просто раскрываем
            openItem($li);
            // запомним URL, чтобы второй тап вёл по ссылке
            if (href && href !== '#') { $a.data('pending-url', href); }
            return;
        }

        // Уже открыт
        if (href && href !== '#' && $a.data('pending-url') === href) {
            // второй тап — идём по ссылке
            window.location.href = href;
            return;
        }

        // иначе закрываем
        closeItem($li);
    });

    // Доступность: Enter/Space тоже раскрывают
    $list.on('keydown', 'li.menu-item-has-children > a', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    // Клики по ссылкам ВНУТРИ подменю — пропускаем (пусть навигируют)
    $list.on('click', '.sub-menu a', function (e) {
        e.stopPropagation(); // чтобы внешние document-click не закрывали раньше времени
    });

})(jQuery);
